import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { UnsubscribeExternalUser } from '~/modules/unsubscribe/externalUser';

import { buildRouteExport } from '~/utils/buildRouteExport';

/**
 * Search params schema for the unsubscribe magic link route.
 */
const zodUnsubscribeSearchParamsSchema = z.object({
  token: z.string().trim().min(10),
});

export const Route = createFileRoute('/(custom)/external/unsubscribe/')({
  component: UnsubscribeExternalUser,
  validateSearch: zodUnsubscribeSearchParamsSchema,
});

export const UNSUBSCRIBE_EXTERNAL = buildRouteExport({ Route });
